import { BaseResource } from 'src/modules/models/base-resource';
//import { BookingItem } from 'src/modules/models/regular-portal/booking/booking-item';
import { BookingItemVm } from 'src/modules/models/regular-portal/booking/manage-teams/booking-item-vm';
import { Venue } from 'src/modules/models/regular-portal/booking/manage-teams/venue';


export class BookingPackage extends BaseResource {

    constructor() {
        super();
        this.type = "BookingPackage";
    }
    startDate: string;
    endDate: string;
    name: string;
    quantity: number;
    attendees: number;
    package: Package;
   // bookingItems: BookingItem[]

    //properties for manage teams
    totalAmount: number;
    packageStart: Date;
    packageEnd: Date;
    recurrentPatternId: string;
    selectedDates: any[]=[];
    unavailableDates: number;
    specialDates: number;
    bookingItem: BookingItemVm[];
    bookingVenues: BookingVenues[];
    venue: Venue;
    unavailableDatesPackage: Date[];
    packageRecurrenceOption: string;
    selectedLocationsCount: number;
    salesCategories: any[] =[];
    seasonalBasePackage: boolean = false;
    isAllSeasonalPerBookingItem: boolean = true;
}
export class BookingVenues {
    constructor() {
        this.type = "BookingVenues";
    }
    type: string;
    venue: Venue;
    bookingItem: BookingItemVm[];
}
export class Package extends BaseResource {
}
